import { InMemoryCache, ApolloClient } from '@apollo/client'

export default function initApolloClient() {
  return new ApolloClient({
    cache: new InMemoryCache(),
    uri: `${process.env.NEXT_PUBLIC_V1_API_URL}management/graphql`,
  })
}
